import { render, staticRenderFns } from "./NewsForm.vue?vue&type=template&id=38b77a6f&scoped=true&"
import script from "./NewsForm.vue?vue&type=script&lang=js&"
export * from "./NewsForm.vue?vue&type=script&lang=js&"
import style0 from "./NewsForm.vue?vue&type=style&index=0&id=38b77a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b77a6f",
  null
  
)

export default component.exports